import * as enums from './Enums';

import { CustomerModel } from './CustomerModel';
import { CardModel } from './CardModel';

export class CompanyModel {

    public constructor(init?: Partial<Pick<CompanyModel, keyof CompanyModel>>) {

        if (init) {
            if (typeof init.createdAt === 'string') {
                init.createdAt = new Date(init.createdAt);
            }
            if (typeof init.accountFilledAt === 'string') {
                init.accountFilledAt = new Date(init.accountFilledAt);
            }
            if (typeof init.billingFilledAt === 'string') {
                init.billingFilledAt = new Date(init.billingFilledAt);
            }
            if (typeof init.updatedAt === 'string') {
                init.updatedAt = new Date(init.updatedAt);
            }
            if (typeof init.disabledAt === 'string') {
                init.disabledAt = new Date(init.disabledAt);
            }
            if (typeof init.formSignedAt === 'string') {
                init.formSignedAt = new Date(init.formSignedAt);
            }
            Object.assign(this, init);
        }
    }

    id = 0;
    name: string;
    description: string;
    phone: string;

    isActive: boolean;
    disabledType: enums.DisabledType;
    disabledAt: Date;
    createdAt: Date;

    accountFilledAt: Date;
    billingFilledAt: Date;
    billingResponseAt: Date = null;
    billingStatus: enums.FormStatus = enums.FormStatus.None;

    whatsappPhone: string;
    orderComments: string;
    acceptNotifications: boolean;
    email: string;
    notificationEmail: string;
    electronicBillingEmail: string;
    locations: string;
    logoURL: string;
    businessName: string;

    idCard: string;
    idCardType: number;
    commerceType: number;

    haciendaType: enums.HaciendaType;

    currencyType = enums.CurrencyType.CRC;

    updatedAt?: Date;
    fourGeeksURL: string;
    ftApiURL: string;

    formSignedAt: Date = null;
    formResponseAt: Date = null;
    formStatus: enums.FormStatus = enums.FormStatus.None;

    isOwn: boolean;

    showCodeQRForms: boolean;
    allowSocialNetwork: boolean;
    allowDiscountCode: boolean;
    initialPromoCode: string;

    province = 0;
    canton = 0;
    district = 0;

    paymentMethodType: enums.PaymentMethodType;

    knowsUsBy: enums.KnowsUsByType;

    useShippingHandling: boolean;

    sellLiquor: boolean;

    createZonesUrl: string;

    //lat: number;
    //lng: number;
    addressDetails: string;
    addressMap: string;


    availablePoints = 0;


    billingInfo: BillingInfoModel;

    customers: CustomerModel[] = [];
}

export class MarketCategory {

    public constructor(init?: Partial<Pick<MarketCategory, keyof MarketCategory>>) {

        if (init) {
            Object.assign(this, init);
        }
    }

    id: number;
    name: string;
    description: string;
    createdAt: Date;
    updatedAt?: Date;
}

export class BillingInfoModel {

    public constructor(init?: Partial<Pick<BillingInfoModel, keyof BillingInfoModel>>) {

        if (init) {
            Object.assign(this, init);
        }
    }

    companyId: number;

    fisicaUrl: string;
    juridicaUrl: string;
    certifiedUrl: string;

    businessActivity: string;

    countries: string;

    rangeAmountPerSales: number;
    amountPerSales: number;

    rangeAmountPerSale: number;
    amountPerSale: number;

    hasPhysicalStore: boolean;
    physicalStore: string;

    productDescription: string;

    bankAccountType: number;
    bankName: string;
    bankAccountOwner: string;
    bankAccountOwnerId: string;
    bankAccountNumber: string;

    productPriceType: number;
    transactionType: number;
}

export class CompanyRepresentativeModel {

    public constructor(init?: Partial<Pick<CompanyRepresentativeModel, keyof CompanyRepresentativeModel>>) {

        if (init) {
            Object.assign(this, init);
        }
    }

    companyId: number;
    name: string;
    lastName: string;
    email: string;
    address: string;
    phone: string;
    idCard: string;
    birthDate: Date;
}



